import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureError } from "./lib/utils";

Sentry.init({
  dsn: "https://8b4e48e830b239020d60bb471359d3d2@o4510723583115264.ingest.us.sentry.io/4510723589996544",
  integrations: [Sentry.browserTracingIntegration()],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.MODE === "prod" ? "production" : (import.meta.env.MODE || "development"),
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // This enables distributed tracing for Supabase API calls and Edge Functions
  // to get around possible Browser CORS issues
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/.*\.supabase\.co\/.*/,  // Matches Supabase REST API, Auth, and Edge Functions
    /^https:\/\/.*\.supabase\.io\/.*/,  // Matches alternative Supabase domains
  ],
  // Log events in development and handle blocked requests
  beforeSend(event, hint) {
    // Log to console in development
    if (import.meta.env.DEV) {
      console.log("[Sentry] Event captured:", event);
      if (hint?.syntheticException) {
        console.warn("[Sentry] Transport error (may be blocked by extension):", hint.syntheticException);
      }
    }
    return event;
  },
});

const container = document.getElementById("root");
if (!container) {
  const error = new Error("Root element not found");
  captureError(error, { location: "main.tsx" });
  throw error;
}

const root = createRoot(container);
root.render(<App />);
